import Preview from "./Preview/Preview";


const DraggableViewPositionProps=["y","x"].map(axis=>({
    name:axis,
    type:"number",
    description:axis+"-position relative to its initial position",
    
}));
const DraggableViewBoundaryProps=["x","y"].flatMap(axis=>["min","max"].map(extremum=>({
    name:axis+extremum,
    type:"number",
    description:`${extremum}imum ${axis} value in pixels`,
})));
const DraggableViewPositionSetter={
    name:"position",
    type:"object",
    /* description:`
        sets the view's position relative to its initial position, not the parent element left and top.
        @to achieve that behavior, set the view's style to position absolute, left 0, top 0
    `, */
    props:[
        ...DraggableViewPositionProps,
        {
            name:"asratio",
            type:"boolean",
            description:`
                if true, x and y values will be multiplied respectively by width and height of the parent element.
                if false, x and y values are pixel values.
                @examples 
                @1) x=1 : left offset of the draggableview is 100% of the width of its parent
                @2) y=0.5 : top offset of the draggableview is 50% of the height of its parent
                @default true when setting the position prop, false when using setPosition method
            `,
        },
        {
            name:"duration",
            type:"number",
            description:"if the value is a positive number, an animation is triggered",
        },
        {
            name:"easing",
            type:"string",
            description:`Animation Easing function. Same as transition-timing-function CSS property @default "ease-out"`,
        },
    ],
};

const DraggableViewCoordsProps=[
    ...DraggableViewPositionProps,
    {
        name:"dx",
        type:"number",
        description:`
            x-distance relative to last position
            @value is always 0 on onDrag event
            @>0 : element went right
            @<0 : element went left
        `,
    },
    {
        name:"dy",
        type:"number",
        description:`
            y-distance relative to last position
            @value is always 0 on onDrag event
            @>0 : element went down
            @<0 : element went up
        `,
    },
];

export default {
    id:"DraggableView",
    parent:{name:"View"},
    description:"draggable element",
    preview:Preview,
    props:[
        DraggableViewPositionSetter,
        {
            name:"boundary",
            type:"object",
            props:DraggableViewBoundaryProps,
        },
        {
            name:"horizontalDrag",
            type:"boolean",
            description:"if false, the view won't move horizontally @default true",
        },
        {
            name:"verticalDrag",
            type:"boolean",
            description:"if false, the view won't move vertically @default true",
        },
        ...["onDrag","onMove","onDrop"].map((name,i)=>({
            name,
            type:"(coords:object,element:DraggableView):void",
            props:(i==2)&&[
                {
                    name:"coords",
                    type:"object",
                    props:DraggableViewCoordsProps,
                }
            ],
        })),
    ],
    methods:[
        {
            name:"setEventListener",
            type:"(type:enum,listener:(coords:object,element:DraggableView)=>void):void",
            description:`
                sets the draggableview event listeners.
                Called without providing a listener will remove the event listener. 
            `,
            props:[
                {
                    name:"type",
                    type:`"drag"|"move"|"drop"`,
                },
                {
                    name:"coords",
                    type:"object",
                    props:DraggableViewCoordsProps,
                },
            ],
        },
        {
            name:"getPosition",
            type:"(asratio:boolean):DraggableViewPosition",
            props:[
                {
                    name:"asratio",
                    type:"boolean",
                    description:`
                        if asratio true returns values as fractions relative to width and height of parent/viewport
                        @default false
                    `,
                },
                {
                    name:"DraggableViewPosition",
                    type:"object",
                    props:DraggableViewPositionProps,
                }
            ],
        },
        {
            name:"setPosition",
            type:"(position:object,triggerOnMove?:boolean):void",
            props:[
                DraggableViewPositionSetter,
                {
                    name:"triggerOnMove",
                    type:"boolean",
                    description:`
                        specifies if this call will trigger the onMove event listener or not
                        @useful when you need to call setPosition inside the onMove listener to avoid the
                        Maximum Call Stack Size Exceeded error.
                        @default true
                    `,
                },
            ],
        },
    ],
}
